import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  divider: {
    margin: theme.spacing(2, 0)
  } as SxProps,

  amountToPayContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  } as SxProps,

  amountToPayText: {
    textAlign: 'left',
    fontWeight: theme.typography.fontWeightBold,
    paddingRight: theme.spacing(2)
  } as SxProps
}

export default styles
